import React from 'react';
import PropTypes from 'prop-types';
import { DeliveryOptions } from '@thd-olt-component-react/delivery-options';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import {
  getDeliveryOptionsText,
  showTodayOrTomorrow,
  isQuantityEqual
} from '../../../helper/utils';

const DeliveryDetails = React.memo(({
  itemId,
  storeId,
  zipCode,
  quantity,
  shippingData,
  isCartTiles = false,
  fallbackMode = false,
  originalConfigId,
  enableCheckNearbyStoreView
}) => {

  const deliveryOptionsText = getDeliveryOptionsText(shippingData);

  return (
    <>
      {(!isCartTiles && !fallbackMode && zipCode && (
        <div className={!enableCheckNearbyStoreView ? 'sui-flex-row sui-pt-3 sui-pb-3' : null}>
          <Typography variant="body-base">
            {!enableCheckNearbyStoreView && (
              deliveryOptionsText
            )}
            <DeliveryOptions
              itemId={itemId}
              storeId={storeId}
              zipCode={zipCode}
              quantity={quantity}
              useDrawer
              showTodayOrTomorrow={showTodayOrTomorrow}
              configId={originalConfigId}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link
                data-testid="delivery-header-zipcode-link"
              >
                Delivery Details
              </Link>

            </DeliveryOptions>
          </Typography>
        </div>
      ))}
    </>
  );
}, isQuantityEqual);

DeliveryDetails.propTypes = {
  itemId: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  zipCode: PropTypes.string,
  storeId: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  shippingData: PropTypes.objectOf(PropTypes.any),
  isCartTiles: PropTypes.bool,
  fallbackMode: PropTypes.bool,
  originalConfigId: PropTypes.string,
  enableCheckNearbyStoreView: PropTypes.bool
};

DeliveryDetails.defaultProps = {
  quantity: 1,
  zipCode: null,
  storeId: null,
  shippingData: {},
  isCartTiles: false,
  fallbackMode: false,
  originalConfigId: null,
  enableCheckNearbyStoreView: false,
};

export { DeliveryDetails };